export default "__VITE_ASSET__IA2CAEPm__"